<div id="acom">
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="inner-card">
                    <h4 class="card-title ">Subjects offered in Class XI</h4>
                    <div class="card-body text-justify">
                        <table class="table table-bordered">
                            <thead>
                                <tr>
                                    <th scope="col" class="text-center">SCIENCE STREAM</th>
                                    <th scope="col" class="text-center">COMMERCE STREAM</th>
                                    <th scope="col" class="text-center">ARTS STREAM</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>English</td>
                                    <td>English</td>
                                    <td>English</td>
                                </tr>
                                <tr>
                                    <td>Physics </td>
                                    <td>Accountancy </td>
                                    <td>Political Science</td>
                                </tr>
                                <tr>
                                    <td>Chemistry </td>
                                    <td>Business Studies </td>
                                    <td>Economics/ Mathematics*</td>
                                </tr>
                                <tr>
                                    <td>Mathematics/ Biology* </td>
                                    <td>Economics/ Mathematics*</td>
                                    <td>History/ Geography*</td>
                                </tr>
                                <tr>
                                    <td>Physical Education/ Sanskrit/ Artificial Intelligence/ Commercial Arts*</td>
                                    <td>Physical Education/ Sanskrit/ Artificial Intelligence/ Commercial Arts*</td>
                                    <td>Physical Education/ Sanskrit/ Artificial Intelligence/ Commercial Arts*</td>
                                </tr>
                            </tbody>
                        </table>
                        <p class="lead text-justify inner-lead fw-bold">*Classes for an optional subject will be run only if it is opted by a minimum of 10 students.</p>


                    </div>
                </div>

            </div>
        </div>


    </div>
</div>